import { connect } from 'react-redux'
// import go from '../actions/utils/Go.js';
// import clean from '../actions/utils/Go.js';
import MaintenanceRefineCardsComponent from '../components/MaintenanceRefineCardsComponent.jsx';
import {
	forwardToFindRefinableMCards,
	forwardToRefineMaintenanceCard,
	forwardToAssignModifyingMCardTarget,
	clean,
	forwardToSortRefinableMaintenanceCards,
	forwardToFindPhotosByCard,
	changePhotoListPreviousPage,
	changeCheckCardPreviousPage,
	forwardToSelectCategory,
	forwardToReloadCheckCard,
	forwardToReloadMaintenanceCase,
	forwardToFindPhotos
} from '../actions';

const mapStateToProps = (state) => ({

	request: state.getIn(['maintenanceRefineReducer', 'request']),
	response: state.getIn(['maintenanceRefineReducer', 'response']),
	options: state.getIn(['maintenanceRefineReducer', 'options']),
	alert: state.getIn(['alertReducer', 'alert']),

	roles: state.getIn(['authReducer', 'roles']),
})

const mapDispatchToProps = (dispatch) => ({
	findRefinableMCards: (pk) => {
		dispatch(forwardToFindRefinableMCards({
			casePk: pk,
			cardStatuss: ['COMPLETED', 'REFINED', 'MODIFIED', 'AUDITED'
			]
		}));
		clean(dispatch);
	},
	refineMCard: (cardPk, casePk, operator) => {
		dispatch(forwardToRefineMaintenanceCard(cardPk, casePk, operator));
		clean(dispatch);
	},
	assignModifyingTarget: (cardPk) => {
		dispatch(forwardToAssignModifyingMCardTarget(cardPk));
		clean(dispatch);
	},
	sortCards: (cards, order) => {
		dispatch(forwardToSortRefinableMaintenanceCards(cards, order));
		clean(dispatch);
	},
	findPhotos: (cardId) => {
		dispatch(forwardToFindPhotosByCard(cardId));
	},
	changePhotoListPreviousPage: (previousPage) => {
		dispatch(changePhotoListPreviousPage(previousPage));
	},
	changeCheckCardPreviousPage: (previousPage) => {
		dispatch(changeCheckCardPreviousPage(previousPage));
	},
	changeCategory: (index) => {
		dispatch(forwardToSelectCategory(index))
	},
	reloadCheckCard: (cardPk) => {
		console.log(cardPk);
		dispatch(forwardToReloadCheckCard(cardPk))
	},
	reloadMaintenanceCase: (casePk) => {
		dispatch(forwardToReloadMaintenanceCase(casePk));
	},
	findPhotosByItemType: (cardPk, category) => {
		let type;
		if (0 === category) {
			type = "CLOTH";
		}
		if (1 === category) {
			type = "PANT";
		}
		dispatch(forwardToFindPhotos({ id: cardPk }, type, "PRE"));
	},
})

const MaintenanceRefineCardsContainer = connect(
	mapStateToProps,
	mapDispatchToProps
)(MaintenanceRefineCardsComponent)

export default MaintenanceRefineCardsContainer;


// WEBPACK FOOTER //
// ./src/containers/MaintenanceRefineCardsContainer.jsx